import { Injectable } from '@angular/core';
import moment from 'moment';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductService {

  constructor(private config: CvConfigurationService) { }

  makeNewPointStoreProduct() {
    let newPointStoreProduct = {
      CompanyID: 0,
      PointStoreProductID: 0,
      ProductImageID: 0,
      Category: null,
      SubCategory: null,
      Title: null,
      Description: null,
      Active: null,
      Price: null,
      Quantity: null,
      Sale: null,
      PointStoreProductAssignments: [],
      PointStoreProductAllAssignments: {
        empAssignAll: true,
        emp: [],
        attr: [],
        coreAssignAtType: null,
        coreAssignAtLevel: null,
      },
      AssignedGroups: false,
      HasProductVariations: false,
      VariationsData: [
        { "id": 1 },
        { "id": 2 }
      ],
      imageString: [],
      IsChecked: false,
      IsDeletedChecked: false,
      ProductStart: new Date(),
      ProductEnd: this.config.isCxOne ? new Date() : null,
      CarouselStart: null,
      CarouselEnd: null,
      FeatureStart: null,
      FeatureEnd: null,
      SaleStart: null,
      SaleEnd: null,
      ProductStart_ForView: moment(new Date()).format(CVMomentDateFormat),
      ProductEnd_ForView: null,
      CarouselStart_ForView: null,
      CarouselEnd_ForView: null,
      SaleStart_ForView: null,
      SaleEnd_ForView: null,
      FeatureStart_ForView: null,
      FeatureEnd_ForView: null,
    };
    return newPointStoreProduct;
  }

  getNewPointStoreProduct() {
    return this.makeNewPointStoreProduct();
  }

  makeNewPointStoreProductSetting() {
    let newPointStoreProductSetting = {
      Carousel: false,
      FeaturedProduct: false,
      Sale: false,
    };
    return newPointStoreProductSetting;
  }

  getNewPointStoreProductSetting() {
    return this.makeNewPointStoreProductSetting();
  }

  makeNewPointStoreProductLandingPage() {
    let newPointStoreProductLandingPage = {
      thumbnail: false,
      list: true,

      editList: false,
      duplicateList: false,
      deleteList: false,
    };
    return newPointStoreProductLandingPage;
  }

  getNewPointStoreProductLandingPage() {
    return this.makeNewPointStoreProductLandingPage();
  }

  makeNewImage() {
    let newImage = {
      CompanyID: 0,
      ImageID: 0,
      ImageType: 6,
      ImageFilePath: null,
      BasePath: null,
      FileName: null,
      FileExtension: null,
      DisplayName: null,
      AltText: null,
      ImageGroup: null,
    };
    return newImage;
  }

  getNewImage() {
    return this.makeNewImage();
  }
}
